import TomSelect from "tom-select"

export function init_creatable_selects(scope = document) {
  scope.querySelectorAll("[data-creatable-select]").forEach(el => {
    if (el.tomselect) return

    // Modal content exists in the DOM but hidden on load; defer until shown.bs.modal fires.
    const modal = el.closest(".modal")
    if (modal && !modal.classList.contains("show")) return

    const createUrl = el.dataset.createUrl
    const placeholder = el.dataset.placeholder || "Select or create..."

    const ts = new TomSelect(el, {
      placeholder,
      createFilter: input => input.trim().length > 0,
      create: (input, callback) => {
        createOption(input.trim(), createUrl).then(callback).catch(() => callback(null))
      },
    })
    if (el.id) ts.wrapper.dataset.testid = el.id
  })
}

if (document.body) {
  init_creatable_selects()
  startObserver()
} else {
  document.addEventListener("DOMContentLoaded", () => {
    init_creatable_selects()
    startObserver()
  })
}

function startObserver() {
  const observer = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          init_creatable_selects(node)
        }
      }
    }
  })
  observer.observe(document.body, { childList: true, subtree: true })

  // MutationObserver misses modal content (hidden on load, not added). Re-init Tom Select when shown.
  document.addEventListener("shown.bs.modal", (event) => {
    init_creatable_selects(event.target)
  })
}

async function createOption(input, url) {
  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content")

  let response
  try {
    response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        ...(csrfToken ? { "X-CSRF-Token": csrfToken } : {}),
      },
      body: JSON.stringify({ name: input }),
    })
  } catch {
    document.dispatchEvent(new CustomEvent("app:toast", {
      detail: { message: "Network error. Could not create option.", type: "danger" },
    }))
    return null
  }

  if (!response.ok) {
    const data = await response.json().catch(() => ({}))
    document.dispatchEvent(new CustomEvent("app:toast", {
      detail: { message: data.error || "Could not create option.", type: "danger" },
    }))
    return null
  }

  const data = await response.json()
  return { value: data.id, text: data.name }
}